import { Injectable } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
    HttpErrorResponse
} from "@angular/common/http";
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from "rxjs";
import { map, catchError, tap } from "rxjs/operators";
import { environment } from 'src/environments/environment';
// import { ToastrService } from 'ngx-toastr';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    public user: any = null;
    serviceData: any;
    customPackage = { "id": 3, "name": "Customized Service", "required": true, "status": true, "isFix": false }
    accessData: any;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        // private toastr: ToastrService
    ) { }

    getLocalstorage() {
        var user: any = localStorage.getItem("currentUser");
        return JSON.parse(user);
    }

    setMyBgColor(colorVal: any) {
        let styles = {
            'background-color': colorVal
        };
        return styles;
    }

    post(url: any, data: any, token: any) {
        const headers = new HttpHeaders().set("Authorization", `Bearer ${token}`);
        return this.http
            .post(environment.APiURL + url, data, {
                headers: headers
            })
            .pipe(catchError(this.handleError));
    }

    postNoToken(url: any, data: any) {
        // const headers = new HttpHeaders().set("", ``);
        return this.http
            .post(environment.APiURL + url, data, {})
            .pipe(catchError(this.handleError));
    }

    postNoData(url: any, token: any) {
        const headers = new HttpHeaders().set("Authorization", `Bearer ${token}`);
        return this.http
            .post(environment.APiURL + url, {
                headers: headers
            })
            .pipe(catchError(this.handleError));
    }

    get(url: any, token: any) {
        const headers = new HttpHeaders().set("Authorization", `Bearer ${token}`);
        return this.http
            .get(environment.APiURL + url, {
                headers: headers
            })
            .pipe(catchError(this.handleError));
    }

    getThirdParty(url: any) {
        return this.http
            .get(url)
            .pipe(catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        if (error.error instanceof ErrorEvent) {
            console.error("An error occurred:", error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` + `body was: ${error.error}`
            );
            if (error.status == 401) {
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = 'account/login';
            }
        }

        return throwError(error.error);
    }
}
